<template>
  <div>
    <search :show.sync="showFilterPop" @handlequery="handleFqueryFilter" :isPerformance="true" />
    <van-cell style="padding: 16px 10px;">
      <van-tag size="large" type='primary' @click="clickTag(item.dayType)" v-for="(item,index) in timeOptions" :key="index" color="#F4F5F7"
        text-color="#606060" :class="activeId === item.dayType?'tag-click':'tag-before'">{{item.value}}</van-tag>
      <van-icon style="margin-left: 10px" size="20" name="filter-o" @click="handleFilter()" />
    </van-cell>
    <van-cell v-if="queryParams.params.beginTime" :title="'时间：' + queryParams.params.beginTime + '至' +  queryParams.params.endTime" />
    <tongji-table v-if="arr.length > 0" :tableData="tableData" :option="option" />
    <empty-component v-if="arr.length === 0" />
  </div>
</template>

<script>
import {
  Grid,
  GridItem
  // Image as VanImage
  // Cascader
} from 'vant'
import search from './component/search.vue'
import statistics from '@/api/tongji/statistics'
import tongjiTable from './component/tongjiTable.vue'
import EmptyComponent from '@/components/common/Empty'
export default {
  name: 'TongjiIndex',
  components: {
    search,
    tongjiTable,
    EmptyComponent,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem
  },
  props: {},
  data() {
    return {
      isScrm: null,
      showFilterPop: false,
      // activeNames: ['1'],
      // icon_title: require('../../assets/images/tj/ghicon.png'),
      activeId: '1',
      queryParams: {
        deptId: null,
        execType: '1',
        params: {
          beginTime: '',
          endTime: ''
        }
      },
      divisionList: [],
      boSuccessList: [],
      boList: [],
      notBoList: [],
      custList: [],
      businessFunnel: [],
      options: {
        boStageIdOptions: []
      },
      arr: [],
      tableData: [],
      // th
      option: {
        column: []
      },
      timeOptions: [{ dayType: '1', value: '昨天' }, { dayType: '0', value: '今天' }, { dayType: '7', value: '本周' }, { dayType: '30', value: '本月' }, { dayType: '180', value: '上半年' }, { dayType: '365', value: '今年' }]
    }
  },
  async created() {
    this.getList()
    this.option.column = [{
      label: '序号',
      tableDataprop: 'index'
    },
    {
      label: '事业部',
      tableDataprop: 'deptName'
    },
    {
      label: '合计回款(含税)',
      tableDataprop: 'payMoney'
    },
    {
      label: '合计回款(不含税)',
      tableDataprop: 'taxMoney'
    }]
  },
  async mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '事业部业绩统计'
    },
    // 获取统计数据
    async getList() {
      await statistics.listAllIncomeSum(this.queryParams).then(res => {
        if (res.code === 200) {
          const arr = res.rows
          this.arr = []
          arr.forEach((item, index) => {
            this.arr.push({ index: index === arr.length - 1 ? '' : index, deptName: item.deptName.replace('事业部', ''), payMoney: item.payMoney, taxMoney: item.taxMoney })
          })
          console.log(this.arr)
          this.tableData = this.arr
        }
      })
    },
    // 设置tableData
    setTableData() {

    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    // 过滤子组件传递过来的搜索对象
    async handleFqueryFilter(data) {
      this.showFilterPop = false
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      if (this.queryParams.startTime || this.queryParams.endTime) {
        this.queryParams.params.beginTime = this.queryParams.startTime
        this.queryParams.params.endTime = this.queryParams.endTime
        this.activeId = null
      } else {
        this.activeId = '1'
      }
      this.getList()
    },
    async clickTag(id) {
      console.log('activeId:' + id)
      this.activeId = id
      this.queryParams.execType = id
      this.queryParams.params.beginTime = ''
      this.queryParams.params.endTime = ''
      this.getList()
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
// *{touch-action: none;}
.van-cell {
  touch-action: none;
}

/deep/.van-cell__value{
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 20px 0px;
}
.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}
.Statistics_title{
  margin-top: 15px;
  background-color: #fff;
  padding: 10px 0;
  font-size: 28px;
  color:#87CEFA;
  text-align: center;
}
.vant-table{
  margin-top: 15px;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 120px;
  .table {
    border: 2px solid #ddd;
    line-height: 65px;
    font-size: 28px;
    text-align: center;
    color: #666;
    .th {
      // height: 1.074074rem;
      // line-height: 60px;
      // font-size: 30px;
      // text-align: center;
      font-weight: 400;
      border-right: 2px solid #ddd;
    }
    .th:last-child {
      border-right: none;
    }
    .list-tr:hover {
      background-color: #f5f5f5;
    }
    // .list-tr:nth-child(2n) {
    //   background-color: #f6f6f6;
    // }
    td {
      border-top: 2px solid #ddd;
      border-right: 2px solid #ddd;
    }
    td:last-child {
      border-right: none;
    }
  }
}

</style>
